// extracted by mini-css-extract-plugin
export default {"warning":"EditViewButton-module__warning--fD37k"};